import { FeatureFlag } from '../FeatureFlag';
import { AdminOMSPropertyOverridesSchema } from 'src/admin/lib/oms/riskPropertyOverrides';
import type { AdminOMSPropertyOverrides } from 'src/admin/lib/oms/riskPropertyOverrides';

export const adminOmsPropertyOverrides = new FeatureFlag<AdminOMSPropertyOverrides>({
    key: 'admin-oms-property-overrides',
    defaultValue: [],
    parseValue: (value: unknown) => {
        // Handle the case where LaunchDarkly returns [null] for an empty array, since LD default on/off JSON can't be the same value
        if (Array.isArray(value) && value.length === 1 && value[0] === null) {
            return [];
        }
        return AdminOMSPropertyOverridesSchema.parse(value);
    },
});
